"use strict";

var regFormWidget = function () {
  var regFormWidgetParams = {
    model: {},
    url: {},
    template: {},
    modalTitle: 'Подтверждение принадлежности договора',
    phoneNumber: null
  };
  var $regBtn = null;
  var timerOn = false;
  var _int = null;

  function resetCaptcha() {
    grecaptcha.reset();
  }

  function renderHtml(templateName, data) {
    var template = Hogan.compile($("#".concat(templateName)).html());
    return template.render(data).replace(/>(\n+\s+)</g, '><').trim();
  }

  function registerUser(regData) {
    $.ajax({
      type: 'POST',
      url: regFormWidgetParams.url.regUser,
      data: regData,
      success: function success(xhr) {
        if (xhr.Success) {
          $('#validate-error').text(''); //Security level maximum -_- 

          if (xhr.Result === 'WithoutConfirmCode') {
            modalCodeCountdown.timerOn = false;
            createUser('0');
          }

          if (xhr.Result === 'CustomerAccountOnly') {
            location.href = regFormWidgetParams.url.afterRegistrationPage;
          }

          if (Array.isArray(xhr.Result) && xhr.Result.length === 1) {
            modalCodeCountdown.timerOn = false; // показываем модалку с одним номером телефона

            $('text[name=phone-number]').text(xhr.Result[0]);
            $('#one-phone-number-modal').showAsModal({
              title: regFormWidgetParams.modalTitle
            });
          }

          if (Array.isArray(xhr.Result) && xhr.Result.length > 1) {
            modalCodeCountdown.timerOn = false; // показываем модалку с несколькими номерами

            var modal = renderHtml('multiple-phone-number-modal', {
              phoneNumbers: xhr.Result
            });
            $(modal).showAsModal({
              title: regFormWidgetParams.modalTitle
            });
          }
        } else {
          switch (xhr.Result.ErrorType) {
            case 'captchaEx':
              $('.text-danger').text(xhr.Result.Error);
              break;

            case 'existUserEx':
              modalDialog.showInfo('Внимание', xhr.Result.Error, null, true);
              break;

            case 'serverEx':
              modalCodeCountdown.timerOn = false;
              modalDialog.showBaseWnd({
                title: 'Ошибка',
                buttons: [{
                  title: 'Хорошо',
                  big: true,
                  primary: true
                }],
                onDrawContent: function onDrawContent() {
                  return xhr.Result.Error;
                }
              });
              break;

            default:
              console.error('Uncatched register user error');
              break;
          }
        }

        resetCaptcha();
        modalDialog.busyIndicator(false);
      },
      error: function error() {
        resetCaptcha();
        modalDialog.busyIndicator(false);
        modalDialog.showBaseWnd({
          title: 'Ошибка',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: function onDrawContent() {
            return 'При отправке произошла сетевая ошибка. Пожалуйста, попробуйте отправить форму заново.';
          }
        });
      }
    });
  }

  function collectContractsData() {
    var contracts = [];
    var $contractsList = $('.person-contract-list').find('.user-list-row.-edited');
    $contractsList.each(function () {
      var $contractRow = $(this);
      var contract = {
        EntityType: $contractRow.find('.person-contract-entity').val(),
        BuldingObject: $contractRow.find('.person-contract-obj :selected').text(),
        BuldingObjectId: $contractRow.find('.person-contract-obj').val(),
        ObjectNumber: $contractRow.find('.person-contract-number').val().trim()
      };
      contracts.push(contract);
    });
    return contracts;
  }

  function setParams(regParams) {
    regFormWidgetParams = $.extend({}, regFormWidgetParams, regParams);
  }

  function unbindHandlers() {
    $(document).off('click', '#addObjectBtn');
    $(document).off('click', '.person-contract-remove');
    $(document).off('change', '#Surname, #Name, #Patronymic, #Email, ' + '.person-contract-number, .person-contract-remove');
    $(document).off('change', '.person-contract-entity, .person-contract-obj');
    $(document).off('click', '#regBtn');
    $(document).off('change', '[data-required] input, .person-contract-number,' + ' #personConfirm');
  }

  function modalMinuteCountdown() {
    timerOn = true;
    var seconds = 60;
    $(".modal-footer.-space-between").show();
    $('#confirm-time').html(seconds);

    var setParam = function setParam() {
      $('#confirm-param').hide();
      $(".modal-footer.-space-between").hide();
      $('#resend-confirm-param').show();
      $('#validate-error').text('');
      $('#confirmation-code').val('');
      $('#confirm-time').html('');
    };

    _int = setInterval(function () {
      $('#confirm-time').html(seconds - 1);
      seconds -= 1;

      if (!timerOn || seconds <= 0) {
        setParam();
        clearInterval(_int);
      }
    }, 1000);
  }

  function createUser(confirmCode) {
    $.ajax({
      type: 'POST',
      url: regFormWidgetParams.url.createProfile,
      data: {
        confirmationCode: confirmCode
      },
      success: function success(xhr) {
        if (xhr.Success) {
          timerOn = false;
          $('#validate-error').text('');
          location.href = xhr.Result;
        } else {
          switch (xhr.Result.ErrorType) {
            case 'validationEx':
              $('#validate-error').text(xhr.Result.ErrorMessage);
              break;

            case 'serverEx':
              $('#validate-error').text('');
              $('#multiple-phone-number-modal').modalDlgClose();
              $('#one-phone-number-modal').modalDlgClose();
              $('#approve-code-modal').modalDlgClose();
              timerOn = false;
              modalDialog.showBaseWnd({
                title: 'Ошибка',
                buttons: [{
                  title: 'Хорошо',
                  big: true,
                  primary: true
                }],
                onDrawContent: function onDrawContent() {
                  return xhr.Result.ErrorMessage;
                }
              });
              break;

            default:
              console.error('Unhandled user creation error');
              break;
          }
        }
      }
    });
  }

  function getConfirmationCode(modalSelector) {
    $.ajax({
      type: 'POST',
      url: regFormWidgetParams.url.sendCodeOnPhone,
      data: {
        phoneNumber: regFormWidgetParams.phoneNumber
      },
      success: function success(xhr) {
        if (xhr.Success) {
          $('#confirm-param').show();
          $('#resend-confirm-param').hide();
          timerOn = false;

          if (modalSelector) {
            $(modalSelector).closest('.modal').modalDlgClose();
            $('#approve-code-modal').showAsModal({
              title: regFormWidgetParams.modalTitle,
              inputs: [{
                id: 'confirmation-code',
                placeholder: 'Полученный код'
              }],
              buttons: [{
                title: 'Подтвердить',
                big: true,
                primary: true,
                onClick: function onClick() {
                  var confirmCode = $('#confirmation-code').val();

                  if (!confirmCode) {
                    $('#validate-error').text('Введите код подтверждения');
                  } else {
                    modalCodeCountdown.timerOn = false;
                    createUser(confirmCode);
                  }

                  return false;
                }
              }]
            });
          }

          modalMinuteCountdown();
        } else {
          modalDialog.showBaseWnd({
            title: 'Ошибка',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return xhr.Result;
            }
          });
        }
      }
    });
  } //%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%


  var modalCodeCountdown = {
    timerOn: true,
    timer: function timer(remaining) {
      // $('#check-validate-error').text('');
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      $('#check-time').html("\u041A\u043E\u0434 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0435\u0449\u0435: ".concat(m, ":").concat(s, " \u0441\u0435\u043A."));
      remaining -= 1;

      if (remaining >= 0 && modalCodeCountdown.timerOn) {
        setTimeout(function () {
          modalCodeCountdown.timer(remaining);
        }, 1000);
        return;
      } else {
        $('#check-confirmation-code').hide();
        $('#resend-check-param').show();
        $('#check-validate-error').text('Код больше не действителен или введен не верно');
        $('#check-time').html('');
      }

      if (!modalCodeCountdown.timerOn) {
        return;
      } // Do timeout stuff here

    }
  };

  function chekConfirmationCode(code) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        type: 'POST',
        url: regFormWidgetParams.url.checkCode,
        data: {
          code: code
        },
        success: function success(xhr) {
          if (xhr.Success) {
            resolve(true);
          } else {
            resolve(false);
          }
        }
      });
    });
  }

  function maskLoginForDisplay(login, type) {
    if (type === 'Phone') {
      var numberForDisplay = login.split('');
      var countNum = login.length;

      if (numberForDisplay[0] === '+') {
        numberForDisplay.shift();
      }

      numberForDisplay.splice(0, countNum - 5, '*'.repeat(countNum - 5));
      return "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043E\u0434, \u0432\u044B\u0441\u043B\u0430\u043D\u043D\u044B\u0439 \u043D\u0430 \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 <span class=\"bold\">".concat(numberForDisplay.join(''), "</span>.");
    } else {
      return "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043E\u0434, \u0432\u044B\u0441\u043B\u0430\u043D\u043D\u044B\u0439 \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B <span class=\"bold\">".concat(login, "</span>.");
    }
  }

  function chekLogin(modalSelector, login, type) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        type: 'POST',
        url: regFormWidgetParams.url.checkData,
        data: {
          data: login,
          type: type
        },
        success: function success(xhr) {
          if (xhr.Success) {
            modalCodeCountdown.timerOn = false;
            $('#check-param').show();
            $('#resend-check-param').hide();

            if (modalSelector) {
              $(modalSelector).closest('.modal').modalDlgClose();
              $('#check-code-modal').showAsModal({
                title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 ".concat(type === 'Phone' ? 'номера телефона' : 'электронной почты'),
                isAutoClosing: false,
                inputs: [{
                  id: 'check-confirmation-code',
                  placeholder: 'Полученный код'
                }],
                buttons: [{
                  title: 'Отправить повторно',
                  id: 'resend-check-param',
                  big: true,
                  primary: false,
                  onClick: function onClick() {
                    $.ajax({
                      type: 'POST',
                      url: regFormWidgetParams.url.checkData,
                      data: {
                        data: login,
                        type: type
                      },
                      success: function success(response) {
                        if (response.Success) {
                          $('#resend-check-param').hide();
                          $('#check-confirmation-code').show();
                          $('#check-confirmation-code').val('');
                          $('#check-validate-error').text('');
                          modalCodeCountdown.timerOn = true;
                          modalCodeCountdown.timer(xhr.Result.LiveTime * 60);
                        } else {
                          $('#check-validate-error').text('Ошибка при запросе кода подтверждения');
                        }
                      }
                    });
                  }
                }, {
                  title: 'Подтвердить',
                  big: true,
                  primary: true,
                  role: 'none',
                  onClick: function onClick() {
                    var confirmCode = $('#check-confirmation-code').val();

                    if (!confirmCode) {
                      $('#check-validate-error').text('Введите код подтверждения');
                    } else {
                      chekConfirmationCode(confirmCode).then(function (res) {
                        if (res) {
                          // Код подтвержден, переходим к регистрации
                          console.log('chekConfirmationCode ---> ', res);
                          $('#check-code-modal').closest('.modal').forceModalDlgClose();
                          resolve(res);
                        } else {
                          // Тут повторная отправка кода подтверждения
                          modalCodeCountdown.timerOn = false;
                          $('#check-confirmation-code').hide();
                          $('#resend-check-param').show();
                        }
                      });
                    }
                  }
                }],
                afterOpen: function afterOpen() {
                  modalCodeCountdown.timerOn = true;
                  modalCodeCountdown.timer(xhr.Result.LiveTime * 60);
                  $('#check-validate-error').text('');
                  $('.modal-dialog').css('width', '450px'); // $('#resend-check-param').hide();

                  $('#checked-phone-number').html(maskLoginForDisplay(login, type));
                  $('[data-btnrole=close]').on('click', function () {
                    $('#check-code-modal').closest('.modal').forceModalDlgClose();
                    $('#check-validate-error').text('');
                    modalCodeCountdown.timerOn = false;
                  });
                }
              });
            }
          } else {
            modalDialog.showBaseWnd({
              title: 'Ошибка',
              buttons: [{
                title: 'Хорошо',
                big: true,
                primary: true
              }],
              onDrawContent: function onDrawContent() {
                return xhr.Result;
              }
            });
          }

          $('#check-validate-error').text('');
        }
      });
    });
  }

  function editMode() {
    var $contractList = $('.person-contract-list');
    $contractList.addClass('-edit-mode');
  }

  function cacheNodes() {
    $regBtn = $('#regBtn');
  }

  function bindHandlers() {
    $(document).on('click', '#addObjectBtn', function () {
      var $contractList = $('.person-contract-list');
      var $contractListBody = $contractList.find('.user-list-body');
      $contractListBody.append($('#contractTemplate').html());
      LKCommon.initExpandedSelectric($contractList.last('.user-list-row').find('.select'));
      $contractList.addClass('-edit-mode');
      $regBtn.attr('disabled', true);
    });

    function newUserListRow() {
      var $contractList = $('.person-contract-list');
      var $contractListBody = $contractList.find('.user-list-body');
      $contractListBody.append($('#contractTemplate').html());
      LKCommon.initExpandedSelectric($contractList.last('.user-list-row').find('.select')); // $contractList.addClass('-edit-mode');

      $regBtn.attr('disabled', true);
    }

    $(document).on('click', '.person-contract-remove', function () {
      var $contractList = $('.person-contract-list');
      var contractsCount = $contractList.find('.user-list-row').length; // $('.user-list-row:first-of-type').remove();

      $(this).closest('.user-list-row').remove();
      newUserListRow(); // if (contractsCount === 1) {
      //     $contractList.removeClass('-edit-mode');
      // }

      var allFilled = validation.validateRegistrationForm();

      if (allFilled) {
        $regBtn.attr('disabled', false);
      } else {
        $regBtn.attr('disabled', true);
      }
    });
    $(document).on('focus', '#Surname, #Name, #Patronymic, #Email, ' + '.person-contract-number, .person-contract-remove', function () {
      var $this = $(this);
      var $field = $this.closest('.field');
      validation.setFieldValid($field);
    });
    $(document).on('change', '.person-contract-entity, .person-contract-obj', function () {
      var $this = $(this);
      var $field = $this.closest('.field');
      validation.setFieldValid($field);
    });
    $(document).on('change', '[data-required] input, .person-contract-number, ' + '#personConfirm', function () {
      var allFilled = validation.validateRegistrationForm();

      if (allFilled) {
        $regBtn.attr('disabled', false);
      } else {
        $regBtn.attr('disabled', true);
      }
    });

    function formatPhoneNumber(phone) {
      return phone.replace(/[^+\d]/g, '');
    }

    function afterConfirmedCode(confirmed, dataSet) {
      if (confirmed) {
        modalDialog.busyIndicator(true);
        registerUser({
          model: {
            Surname: dataSet.Surname,
            Name: dataSet.Name,
            Patronymic: dataSet.Patronymic,
            Email: dataSet.Email,
            PhoneNumber: dataSet.PhoneNumber,
            SelectedContracts: dataSet.ContractBindingList.filter(function (item) {
              return item.EntityType === 'clientContract';
            }),
            SelectedCustomerAccounts: dataSet.ContractBindingList.filter(function (item) {
              return item.EntityType === 'customerAccount';
            })
          },
          captchaKey: getCaptcha()
        });
      } else {
        modalDialog.showBaseWnd({
          title: 'Регистрация не пройдена',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: 'Вы не прошли регистрацию.'
        });
        return;
      }
    }

    $(document).on('click', '#regBtn', function () {
      var validations = ['validateValuesLength', 'validateRequiredValues', 'validatePattern', 'validateContracts'];
      var isValid = true;
      var iti = window.intlTelInputGlobals.getInstance($('#PhoneNumber')[0]);
      var dataSet = {
        Surname: $('#Surname').val().trim(),
        Name: $('#Name').val().trim(),
        Patronymic: $('#Patronymic').val().trim(),
        Email: $('#Email').val().trim(),
        PhoneNumber: iti.getNumber(intlTelInputUtils.numberFormat.E164),
        ExistingContractsList: [],
        ContractBindingList: collectContractsData()
      };
      validations.forEach(function (check) {
        var passedValidation = validation[check](dataSet);
        isValid = isValid && passedValidation;
      });

      if (isValid) {
        var loginType, login;

        if (dataSet.PhoneNumber) {
          //Проверяем телефон
          chekLogin('#main-phone-number-modal', dataSet.PhoneNumber, 'Phone').then(function (res) {
            afterConfirmedCode(res, dataSet);
          });
        } else {
          //Ничего подтверждать не надо
          afterConfirmedCode(true, dataSet);
        }
      }
    });
    $(document).on('click', '#one-phone-send, #multiple-phone-send, #resend-link', function () {
      switch ($(this).attr('id')) {
        case 'one-phone-send':
          regFormWidgetParams.phoneNumber = $('[name=phone-number]').first().text();
          getConfirmationCode('#one-phone-modal-content');
          break;

        case 'multiple-phone-send':
          regFormWidgetParams.phoneNumber = $('.modal-dialog #select-phone-number option:selected').text();
          getConfirmationCode('#multiple-phone-modal-content');
          break;

        case 'resend-link':
          getConfirmationCode(null);
          break;

        default:
          console.error('Such button is not defined');
          break;
      }
    });
  }

  function init(regParams) {
    unbindHandlers();
    LKCommon.initExpandedSelectric($('.person-contract-list').last('.user-list-row').find('.select'));
    setParams(regParams);
    cacheNodes();
    bindHandlers();
    editMode();
  }

  return {
    init: init
  };
}();